import { Outlet } from 'react-router-dom';
import { Sparkles } from 'lucide-react';

export default function AuthLayout() {
    return (
        <div className="min-h-screen bg-dark-950 flex">
            {/* Left side - Branding */}
            <div className="hidden lg:flex lg:w-1/2 bg-gradient-to-br from-primary-600 to-primary-900 p-12 flex-col justify-between">
                <div className="flex items-center gap-3">
                    <div className="w-12 h-12 bg-white/20 rounded-xl flex items-center justify-center">
                        <Sparkles className="w-7 h-7 text-white" />
                    </div>
                    <span className="text-2xl font-bold text-white">aiOps</span>
                </div>

                <div>
                    <h1 className="text-4xl font-bold text-white mb-4">
                        Your Complete AI Ecosystem
                    </h1>
                    <p className="text-xl text-primary-100">
                        Access powerful AI capabilities for marketing, automation, content generation, analytics, and beyond — all in one unified platform.
                    </p>
                </div>

                <div className="space-y-4">
                    <div className="flex items-center gap-3 text-primary-100">
                        <div className="w-8 h-8 bg-white/20 rounded-lg flex items-center justify-center">✓</div>
                        <span>RAG + TAG + MCP AI Architecture</span>
                    </div>
                    <div className="flex items-center gap-3 text-primary-100">
                        <div className="w-8 h-8 bg-white/20 rounded-lg flex items-center justify-center">✓</div>
                        <span>220+ AI Tools via Model Context Protocol</span>
                    </div>
                    <div className="flex items-center gap-3 text-primary-100">
                        <div className="w-8 h-8 bg-white/20 rounded-lg flex items-center justify-center">✓</div>
                        <span>Marketing + Developer AI + Business Ops</span>
                    </div>
                    <div className="flex items-center gap-3 text-primary-100">
                        <div className="w-8 h-8 bg-white/20 rounded-lg flex items-center justify-center">✓</div>
                        <span>18 Modules — True AI Ecosystem</span>
                    </div>
                </div>
            </div>

            {/* Right side - Auth form */}
            <div className="flex-1 flex items-center justify-center p-8">
                <div className="w-full max-w-md">
                    <Outlet />
                </div>
            </div>
        </div>
    );
}
